import type { ReactNode } from 'react';
import { cn } from '@perch/ui-tokens';

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  iconColor?: 'emerald' | 'coral' | 'amber' | 'stone';
  className?: string;
}

const iconBg = {
  emerald: 'bg-emerald-50 dark:bg-emerald-900/30',
  coral: 'bg-[rgba(255,107,53,0.08)]',
  amber: 'bg-amber-50 dark:bg-amber-900/30',
  stone: 'bg-stone-100 dark:bg-stone-800',
} as const;

export function EmptyState({
  icon,
  title,
  description,
  action,
  iconColor = 'stone',
  className,
}: EmptyStateProps) {
  return (
    <div className={cn('py-12 text-center', className)}>
      <div className={cn(
        'w-12 h-12 mx-auto mb-4 rounded-full flex items-center justify-center',
        iconBg[iconColor],
      )}>
        {icon}
      </div>
      <p className="text-stone-600 dark:text-stone-400 font-medium">{title}</p>
      {description && (
        <p className="text-stone-500 dark:text-stone-500 text-sm mt-1">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
